module.exports = __webpack_public_path__ + "img/icon.5681159.png";